import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

/**
 * Core Enum Fanout Step
 *
 * Loads all options from a configured Core Enum and outputs them as an array.
 * When connected to a downstream step that expects a single option,
 * the workflow engine automatically fans out into child workflows — one per option.
 *
 * Useful for testing fanout behavior and for workflows that need to
 * iterate over enum options (e.g., per-division or per-category processing).
 */
export const coreEnumFanoutStep = defineStepConfig({
  type: "core_enum_fanout",
  name: "Enum Fanout",
  description:
    "Loads options from an Enum and outputs them as an array for fanout",
  category: "Data Access",

  inputSchema: z.object({}),

  outputSchema: z.object({
    option: z
      .array(
        z.object({
          id: z.string(),
          name: z.string().nullable(),
          description: z.string().nullable(),
          sortOrder: z.number(),
        }),
      )
      .describe("Full option object"),
    id: z.array(z.string()).describe("Option ID"),
    name: z.array(z.string().nullable()).describe("Option name"),
    description: z.array(z.string().nullable()).describe("Option description"),
    sortOrder: z.array(z.number()).describe("Option sort order"),
  }),

  configSchema: z.object({
    coreEnumId: z.string().describe("The Core Enum to load options from"),
  }),

  emits: [] as const,
});
